import * as Util from '../util'
import * as Icons from './icons'

const resolvePath = (path) => {
  return Util.resolvePath(path);
};

const AlbumWhiteImage = Icons.album_white_24dp;
const ArrowBackWhiteImage = Icons.arrow_back_white_24dp; //resolvePath("images/common/arrow_back_white_24dp.svg");
const ChevronLeftWhiteImage = Icons.chevron_left_white_24dp; //resolvePath("images/common/chevron_left_white_24dp.svg");
const ChevronRightWhiteImage = Icons.chevron_right_white_24dp; //resolvePath("images/common/chevron_right_white_24dp.svg");
const CloudBlackImage = Icons.cloud_black_24dp; //resolvePath("images/common/cloud_black_24dp.svg");
const CloudWhiteImage = Icons.cloud_white_24dp; //resolvePath("images/common/cloud_white_24dp.svg");
const CloudDownloadBlackImage = Icons.cloud_download_black_24dp; //resolvePath("images/common/cloud_download_black_24dp.svg");
const CloudDownloadWhiteImage = Icons.cloud_download_white_24dp; //resolvePath("images/common/cloud_download_white_24dp.svg");
const CloudUploadBlackImage = Icons.cloud_upload_black_24dp;
const CloudUploadWhiteImage = Icons.cloud_upload_white_24dp;
const DeleteForeverBlackImage = Icons.delete_forever_black_24dp; //resolvePath("images/common/delete_forever_black_24dp.svg");
const DeleteForeverWhiteImage = Icons.delete_forever_white_24dp; //resolvePath("images/common/delete_forever_white_24dp.svg");
const DescriptionBlackImage = Icons.description_black_24dp; //resolvePath("images/common/description_black_24dp.svg");
const DescriptionWhiteImage = Icons.description_white_24dp; //resolvePath("images/common/description_white_24dp.svg");
const GamepadWhiteImage = Icons.gamepad_white_24dp; //resolvePath("images/common/gamepad_white_24dp.svg");
const KeyboardWhiteImage = Icons.keyboard_white_24dp; //resolvePath("images/common/keyboard_white_24dp.svg");
const AddCircleBlackImage = Icons.add_circle_outline_black_24dp; //resolvePath("images/common/add_circle_outline_black_24dp.svg");
const AddCircleWhiteImage = Icons.add_circle_outline_white_24dp; //resolvePath("images/common/add_circle_outline_white_24dp.svg");
const PlayArrowBlackImage = Icons.play_arrow_black_24dp; //resolvePath("images/common/play_arrow_black_24dp.svg");
const LoaderImage = Icons.loader;
const LinkBlackImage = Icons.link_black_24dp;
const LinkWhiteImage = Icons.link_white_24dp;
const LinkOffBlackImage = Icons.link_off_black_24dp;
const LinkOffWhiteImage = Icons.link_off_white_24dp;
const ListsWhiteImage = Icons.lists_white_24dp;
const PauseWhiteImage = Icons.pause_white_24dp;
const PlayArrowWhiteImage = Icons.play_arrow_white_24dp; //resolvePath("images/common/play_arrow_white_24dp.svg");
const TuneWhiteImage = Icons.tune_white_24dp; //resolvePath("images/common/tune_white_24dp.svg");
const VolumeOffBlackImage = Icons.volume_off_black_24dp; //resolvePath("images/common/volume_off_black_24dp.svg");
const WebrcadeLogoDarkImage = Icons.webrcade_logo_dark; //resolvePath("images/common/webrcade-logo-dark.svg");
const WebrcadeLogoLargeImage = Icons.webrcade_logo_large; //resolvePath("images/common/webrcade-logo-large.svg");
const SaveWhiteImage = Icons.save_white_24dp;
const SettingsRedImage = Icons.settings_red_24dp; //resolvePath("images/common/settings_red_24dp.svg");
const SearchWhiteImage = Icons.search_white_24dp;
const SettingsWhiteImage = Icons.settings_white_24dp; //resolvePath("images/common/settings_white_24dp.svg");
const SettingsAppWhiteImage = Icons.settings_applications_white_24dp;
const TelevisionWhiteImage = Icons.tv_white_24dp; //resolvePath("images/common/tv_white_24dp.svg");
const MouseWhiteImage = Icons.mouse_white_24dp;
const SwipeWhiteImage = Icons.swipe_white_24dp;
const ArrowUpwardImage = Icons.arrow_upward_24dp;
const ArrowDownwardImage = Icons.arrow_downward_24dp;
const ArrowBackImage = Icons.arrow_back_24dp;
const ArrowForwardImage = Icons.arrow_forward_24dp;
const SwapVertImage = Icons.swap_vert_24dp;
const VideoGameAssetWhiteImage = Icons.videogame_asset_white_24dp;
const VideoGameAssetOffWhiteImage = Icons.videogame_asset_off_white_24dp;
const SelectWindowImage = Icons.select_window_24dp;
const SplitSceneImage = Icons.split_scene_24dp;
const MicrophoneImage = Icons.microphone_white_24dp;
const BlurImage = Icons.blur_on_24dp;
const BoltWhiteImage = Icons.bolt_white_24dp;
const EmojiEventsWhiteImage = Icons.emoji_events_white_24dp;
const LockWhiteImage = Icons.lock_white_24dp;
const ExtensionImage = Icons.extension_24dp;

const CategoryThumbImage = resolvePath("images/folder.png");
const CategoryBackgroundImage = resolvePath("images/folder-background.png");
const FeedThumbImage = resolvePath("images/feed.png");
const FeedBackgroundImage = resolvePath("images/feed-background.png");
const XboxOneDpad = resolvePath("images/common/controller/Xbox One/XboxOne_Dpad.png");
const XboxOneDpadLeft = resolvePath("images/common/controller/Xbox One/XboxOne_Dpad_Left.png");
const XboxOneDpadRight = resolvePath("images/common/controller/Xbox One/XboxOne_Dpad_Right.png");
const XboxOneDpadUp = resolvePath("images/common/controller/Xbox One/XboxOne_Dpad_Up.png");
const XboxOneDpadDown = resolvePath("images/common/controller/Xbox One/XboxOne_Dpad_Down.png");
const XboxOneAButton = resolvePath("images/common/controller/Xbox One/XboxOne_A.png");
const XboxOneBButton = resolvePath("images/common/controller/Xbox One/XboxOne_B.png");
const XboxOneXButton = resolvePath("images/common/controller/Xbox One/XboxOne_X.png");
const XboxOneYButton = resolvePath("images/common/controller/Xbox One/XboxOne_Y.png");
const XboxOneLeftStick = resolvePath("images/common/controller/Xbox One/XboxOne_Left_Stick.png");
const XboxOneLeftStickUp = resolvePath("images/common/controller/Xbox One/XboxOne_Left_Stick_Up.png");
const XboxOneLeftStickDown = resolvePath("images/common/controller/Xbox One/XboxOne_Left_Stick_Down.png");
const XboxOneLeftStickLeft = resolvePath("images/common/controller/Xbox One/XboxOne_Left_Stick_Left.png");
const XboxOneLeftStickRight = resolvePath("images/common/controller/Xbox One/XboxOne_Left_Stick_Right.png");
const XboxOneRightStick = resolvePath("images/common/controller/Xbox One/XboxOne_Right_Stick.png");
const XboxOneRightStickUp = resolvePath("images/common/controller/Xbox One/XboxOne_Right_Stick_Up.png");
const XboxOneRightStickDown = resolvePath("images/common/controller/Xbox One/XboxOne_Right_Stick_Down.png");
const XboxOneRightStickLeft = resolvePath("images/common/controller/Xbox One/XboxOne_Right_Stick_Left.png");
const XboxOneRightStickRight = resolvePath("images/common/controller/Xbox One/XboxOne_Right_Stick_Right.png");
const XboxOneLeftStickClick = resolvePath("images/common/controller/Xbox One/XboxOne_Left_Stick_Click.png");
const XboxOneRightStickClick = resolvePath("images/common/controller/Xbox One/XboxOne_Right_Stick_Click.png");
const XboxOneMenuButton = resolvePath("images/common/controller/Xbox One/XboxOne_Menu.png");
const XboxOneWindowsButton = resolvePath("images/common/controller/Xbox One/XboxOne_Windows.png");
const XboxOneRightBumper = resolvePath("images/common/controller/Xbox One/XboxOne_RB.png");
const XboxOneLeftBumper = resolvePath("images/common/controller/Xbox One/XboxOne_LB.png");
const XboxOneRightTrigger = resolvePath("images/common/controller/Xbox One/XboxOne_RT.png");
const XboxOneLeftTrigger = resolvePath("images/common/controller/Xbox One/XboxOne_LT.png");
const ArrowLeftKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Arrow_Left_Key_Dark.png");
const ArrowRightKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Arrow_Right_Key_Dark.png");
const ArrowUpKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Arrow_Up_Key_Dark.png");
const ArrowDownKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Arrow_Down_Key_Dark.png");
const EscapeKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Esc_Key_Dark.png");
const EnterKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Enter_Key_Dark.png");
const ShiftKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Shift_Key_Dark.png");
const ControlKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Ctrl_Key_Dark.png");
const SpaceKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Space_Key_Dark.png");
const AKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/A_Key_Dark.png");
const CKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/C_Key_Dark.png");
const DKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/D_Key_Dark.png");
const IKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/I_Key_Dark.png");
const JKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/J_Key_Dark.png");
const KKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/K_Key_Dark.png");
const LKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/L_Key_Dark.png");
const SKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/S_Key_Dark.png");
const VKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/V_Key_Dark.png");
const XKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/X_Key_Dark.png");
const ZKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Z_Key_Dark.png");
const QKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Q_Key_Dark.png");
const WKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/W_Key_Dark.png");
const TKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/T_Key_Dark.png");
const RKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/R_Key_Dark.png");
const EKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/E_Key_Dark.png");
const PeriodKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Period_Key_Dark.png");

const ZeroKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/0_Key_Dark.png");
const OneKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/1_Key_Dark.png");
const TwoKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/2_Key_Dark.png");
const ThreeKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/3_Key_Dark.png");
const FourKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/4_Key_Dark.png");
const FiveKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/5_Key_Dark.png");
const SixKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/6_Key_Dark.png");
const SevenKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/7_Key_Dark.png");
const EightKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/8_Key_Dark.png");
const NineKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/9_Key_Dark.png");
const MinusKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Minus_Key_Dark.png");
const EqualsKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Equals_Key_Dark.png");
const SlashKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Slash_Key_Dark.png");
const BackspaceAltKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Backspace_Alt_Key_Dark.png");

const F5Key = resolvePath("images/common/controller/Keyboard & Mouse/Dark/F5_Key_Dark.png");
const F7Key = resolvePath("images/common/controller/Keyboard & Mouse/Dark/F7_Key_Dark.png");

const Atari2600Background = resolvePath("images/app/2600-background.png");
const Atari7800Background = resolvePath("images/app/7800-background.png");
const ThreedoBackground = resolvePath("images/app/3do-background.png");
const NesBackground = resolvePath("images/app/nes-background.png");
const SnesBackground = resolvePath("images/app/snes-background.png");
const GbaBackground = resolvePath("images/app/gba-background.png");
const GbBackground = resolvePath("images/app/gb-background.png");
const GbcBackground = resolvePath("images/app/gbc-background.png");
const GenesisBackground = resolvePath("images/app/genesis-background.png");
const GameGearBackground = resolvePath("images/app/gamegear-background.png");
const MasterSystemBackground = resolvePath("images/app/mastersystem-background.png");
const Sg1000Background = resolvePath("images/app/sg1000-background.png");
const PceBackground = resolvePath("images/app/pce-background.png");
const SgxBackground = resolvePath("images/app/sgx-background.png");
const NgpBackground = resolvePath("images/app/ngp-background.png");
const NgcBackground = resolvePath("images/app/ngc-background.png");
const LynxBackground = resolvePath("images/app/lynx-background.png");
const WscBackground = resolvePath("images/app/wsc-background.png");
const WsBackground = resolvePath("images/app/ws-background.png");
const VbBackground = resolvePath("images/app/vb-background.png");
const PceCdBackground = resolvePath("images/app/pcecd-background.png");
const SegaCdBackground = resolvePath("images/app/segacd-background.png");
const PsxBackground = resolvePath("images/app/playstation-background.png");
const CapcomBackground = resolvePath("images/app/capcom-background.png");
const KonamiBackground = resolvePath("images/app/konami-background.png");
const NeoGeoBackground = resolvePath("images/app/neogeo-background.png");
const NeoGeoCdBackground = resolvePath("images/app/neogeocd-background.png");
const ArcadeBackground = resolvePath("images/app/arcade-background.png");
const N64Background = resolvePath("images/app/n64-background.png");
const A5200Background = resolvePath("images/app/5200-background.png");
const ColecoVisionBackground = resolvePath("images/app/colecovision-background.png");
const ColecoController = resolvePath("images/app/coleco/controller.png");
const A5200Controller = resolvePath("images/app/a5200/controller.png");
const ScummVmBackground = resolvePath("images/app/scummvm-background.png");
const Commodore64Background = resolvePath("images/app/c64-background.png");
const DosBackground = resolvePath("images/app/dos-background.png");
const NdsBackground = resolvePath("images/app/nds-background.png");
const PokeminiBackground = resolvePath("images/app/pokemini-background.png");
const SaturnBackground = resolvePath("images/app/saturn-background.png");
const AstrocadeKeypad = resolvePath("images/app/astrocade/keypad.png");
const AstrocadeBackground = resolvePath("images/app/astrocade-background.png");
const Apple2Background = resolvePath("images/app/apple2-background.png");
const CdiBackground = resolvePath("images/app/cdi-background.png");

export {
  AddCircleBlackImage,
  AddCircleWhiteImage,
  AlbumWhiteImage,
  ArrowBackWhiteImage,
  CategoryThumbImage,
  CategoryBackgroundImage,
  ChevronLeftWhiteImage,
  ChevronRightWhiteImage,
  CloudBlackImage,
  CloudWhiteImage,
  CloudDownloadBlackImage,
  CloudDownloadWhiteImage,
  CloudUploadBlackImage,
  CloudUploadWhiteImage,
  DeleteForeverBlackImage,
  DeleteForeverWhiteImage,
  DescriptionBlackImage,
  DescriptionWhiteImage,
  FeedThumbImage,
  FeedBackgroundImage,
  GamepadWhiteImage,
  KeyboardWhiteImage,
  LoaderImage,
  LinkBlackImage,
  LinkWhiteImage,
  LinkOffBlackImage,
  LinkOffWhiteImage,
  PauseWhiteImage,
  PlayArrowBlackImage,
  PlayArrowWhiteImage,
  SaveWhiteImage,
  SearchWhiteImage,
  SettingsRedImage,
  SettingsWhiteImage,
  SettingsAppWhiteImage,
  TelevisionWhiteImage,
  TuneWhiteImage,
  WebrcadeLogoDarkImage,
  WebrcadeLogoLargeImage,
  VolumeOffBlackImage,
  ExtensionImage,
  EmojiEventsWhiteImage,
  LockWhiteImage,
  XboxOneAButton,
  XboxOneBButton,
  XboxOneXButton,
  XboxOneYButton,
  XboxOneDpad,
  XboxOneLeftStick,
  XboxOneLeftStickUp,
  XboxOneLeftStickDown,
  XboxOneLeftStickLeft,
  XboxOneLeftStickRight,
  XboxOneRightStick,
  XboxOneRightStickUp,
  XboxOneRightStickDown,
  XboxOneRightStickLeft,
  XboxOneRightStickRight,
  XboxOneLeftStickClick,
  XboxOneRightStickClick,
  XboxOneMenuButton,
  XboxOneWindowsButton,
  XboxOneRightBumper,
  XboxOneLeftBumper,
  XboxOneRightTrigger,
  XboxOneLeftTrigger,
  XboxOneDpadLeft,
  XboxOneDpadRight,
  XboxOneDpadUp,
  XboxOneDpadDown,
  ArrowUpKey,
  ArrowDownKey,
  ArrowLeftKey,
  ArrowRightKey,
  ControlKey,
  EnterKey,
  EscapeKey,
  ShiftKey,
  SpaceKey,
  AKey,
  CKey,
  DKey,
  IKey,
  JKey,
  KKey,
  LKey,
  QKey,
  SKey,
  VKey,
  WKey,
  XKey,
  ZKey,
  TKey,
  RKey,
  EKey,
  PeriodKey,
  F5Key,
  F7Key,
  ZeroKey,
  OneKey,
  TwoKey,
  ThreeKey,
  FourKey,
  FiveKey,
  SixKey,
  SevenKey,
  EightKey,
  NineKey,
  MinusKey,
  EqualsKey,
  SlashKey,
  BackspaceAltKey,
  NesBackground,
  SnesBackground,
  GbBackground,
  GbaBackground,
  GbcBackground,
  GenesisBackground,
  GameGearBackground,
  MasterSystemBackground,
  Sg1000Background,
  PceBackground,
  SgxBackground,
  NgpBackground,
  NgcBackground,
  LynxBackground,
  WscBackground,
  WsBackground,
  VbBackground,
  PceCdBackground,
  SegaCdBackground,
  PsxBackground,
  CapcomBackground,
  KonamiBackground,
  NeoGeoBackground,
  NeoGeoCdBackground,
  ArcadeBackground,
  N64Background,
  ColecoVisionBackground,
  ColecoController,
  Commodore64Background,
  A5200Controller,
  A5200Background,
  ThreedoBackground,
  Atari2600Background,
  Atari7800Background,
  DosBackground,
  NdsBackground,
  ListsWhiteImage,
  ScummVmBackground,
  PokeminiBackground,
  SaturnBackground,
  MouseWhiteImage,
  SwipeWhiteImage,
  ArrowUpwardImage,
  ArrowDownwardImage,
  ArrowBackImage,
  ArrowForwardImage,
  SwapVertImage,
  VideoGameAssetWhiteImage,
  VideoGameAssetOffWhiteImage,
  SelectWindowImage,
  SplitSceneImage,
  MicrophoneImage,
  BlurImage,
  BoltWhiteImage,
  AstrocadeKeypad,
  AstrocadeBackground,
  Apple2Background,
  CdiBackground,

  resolvePath as resolveImagePath
}
